"use client"

import { useState, useEffect } from "react"
import AppMenu from "../../Mescomposants/AppMenu"
import { toast } from "react-toastify"
import { useTheme } from "../../contexts/ThemeContext"
import { useNavigate } from "react-router-dom"
// import { adminEmail, crudData, fullUrl, defaultImage } from "../../services/apiService"
import { adminEmails, crudData, fullUrl, defaultImage } from "../../services/apiService"
import { formatPrice } from "./Cart"
import { useOrdersContext } from "../../contexts/OrdersContext"
import Select from "react-select"

// Ajout des styles globaux pour les animations
const styleSheet = document.createElement("style")
styleSheet.type = "text/css"
styleSheet.innerText = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes shimmer {
    0% { background-position: -1000px 0; }
    100% { background-position: 1000px 0; }
  }
  
  .livraison-container {
    animation: fadeIn 0.5s ease-out;
  }
  
  .btn-validation {
    transition: all 0.3s ease;
  }
  
  .btn-validation:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(59, 89, 152, 0.3);
  }
  
  .loading-skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 1000px 100%;
    animation: shimmer 2s infinite;
    border-radius: 4px;
  }
  
  .page-content {
    background-color: #F8FAFD;
    padding: 30px 0;
  }
  
  .livraison-header {
    position: relative;
    overflow: hidden;
  }
  
  .livraison-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(59, 89, 152, 0.1) 0%, rgba(59, 89, 152, 0) 100%);
    z-index: 0;
  }
  
  .form-control:focus {
    border-color: #3B5998;
    box-shadow: 0 0 0 0.2rem rgba(59, 89, 152, 0.25);
  }
  
  .select-box select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%233B5998' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
    padding-right: 30px;
  }
  
  .product-row {
    transition: all 0.3s ease;
  }
  
  .product-row:hover {
    background-color: rgba(59, 89, 152, 0.03);
  }
  
  .loader {
    width: 20px;
    height: 20px;
    border: 2px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
  
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  .summary-card {
    position: relative;
    overflow: hidden;
  }
  
  .summary-card::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, rgba(59, 89, 152, 0.1) 0%, rgba(59, 89, 152, 0) 70%);
    z-index: 0;
  }
`
document.head.appendChild(styleSheet)

const Livraison = ({ onSuccess, param = {} }) => {
  const { theme, toggleTheme } = useTheme()
  const { fetchUserSumAmountOrders } = useOrdersContext()

  const mode = JSON.parse(localStorage.getItem("appMode"))
  const date = JSON.parse(localStorage.getItem("appDate"))
  const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"))
  const paths = JSON.parse(localStorage.getItem("appPaths"))
  const [user, setUser] = useState(null)
  const [productData, setProductData] = useState([])
  const [cart, setCart] = useState([])
  const [quantities, setQuantities] = useState({})
  const navigate = useNavigate()
  const [statusCode, setStatusCode] = useState(null) // Code statut HTTP
  const [isLoading, setIsLoading] = useState(false)
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [zones, setZones] = useState([])
  const [selectedZone, setSelectedZone] = useState(null)
  const [deliveryAddress, setDeliveryAddress] = useState(null)
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  /*Pagination*/
  const [currentPage, setCurrentPage] = useState(1)
  const itemPerPage = 4
  const [currentData, setCurrentData] = useState([])
  const indexOfLastItem = currentPage * itemPerPage
  const indexOfFirstItem = indexOfLastItem - itemPerPage

  useEffect(() => {
    setCurrentData(productData.slice(indexOfFirstItem, indexOfLastItem))
  }, [currentPage, productData])

  const handleNextPage = () => {
    if (indexOfLastItem < productData.length) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const handlePreviousPage = () => {
    if (indexOfFirstItem > 0) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }
  /*Pagination*/

  const fetchZoneData = (params, url) => {
    crudData(params, url)
      .then((response) => {
        if (response && response.status === 200) {
          const zones = response.data.data || [] // Ensure it's an array
          setZones(Array.isArray(zones) ? zones : []) // Safeguard to ensure it's an array
          setStatusCode(response.status)
        } else {
          console.error("Erreur HTTP:", response)
          setStatusCode(response?.status || "Unknown error")
        }
      })
      .catch((error) => {
        setStatusCode(404)
        console.error("Erreur lors de la récupération des données:", error)
      })
  }

  const fetchData = (params, url, setProductData) => {
    setIsLoading(true)
    crudData(params, url)
      .then((response) => {
        if (response && response.status === 200) {
          const produitVeto = response.data.lines || [] // Ensure it's an array
          setProductData(Array.isArray(produitVeto) ? produitVeto : []) // Safeguard to ensure it's an array
          setStatusCode(response.status)

          const initialQuantities = produitVeto.reduce((acc, product) => {
            acc[product.PlvID] = product.PlvQteUV
            return acc
          }, {})
          setQuantities(initialQuantities)
        } else {
          console.error("Erreur HTTP:", response)
          setStatusCode(response?.status || "Unknown error")
        }
      })
      .catch((error) => {
        setStatusCode(404)
        console.error("Erreur lors de la récupération des données:", error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const fetchPanierData = (params, url, setProductData) => {
    crudData(params, url)
      .then((response) => {
        if (response && response.status === 200) {
          const produitVeto = response.data.data || [] // Ensure it's an array
          setCart(produitVeto)
        } else {
          console.error("Erreur HTTP:", response)
          setStatusCode(response?.status || "Unknown error")
        }
      })
      .catch((error) => {
        setStatusCode(404)
        console.error("Erreur lors de la récupération des données:", error)
      })
  }

  useEffect(() => {
    if (isSuccess) {
      let isRequestSent = false

      if (!isRequestSent) {
        const payload = {
          mode: "sendEmail",
          LG_LSTID: "MSG_ORDER_VALIDATION",
          // TO: adminEmail,
          TO: adminEmails.join(","),
        }
        try {
          crudData(payload, "ConfigurationManager.php").then((response) => {
            const { desc_statut, code_statut } = response.data
            if (code_statut !== "0") {
              console.log("error")
            }
            isRequestSent = true
          })
        } catch (error) {
          console.error(error)
        }
      }
    }
  }, [isSuccess])

  const ClotuteCommproduit = (params, url) => {
    setIsLoadingSpinner(true)
    crudData(params, url)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code_statut === "1") {
            toast.success("Commande validée avec succès")
            toast.success(response.data.desc_statut)
            setCart([])
            setSelectedZone(null)
            setDeliveryAddress(null)
            setProductData([])
            onSuccess()
            setIsSuccess(true)
            fetchUserSumAmountOrders()
            navigate("/")
          } else {
            toast.error("Erreur : " + response.data.desc_statut)
          }
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error)
      })
      .finally(() => {
        setIsLoadingSpinner(false)
      })
  }

  useEffect(() => {
    if (!userData) {
      navigate(paths.signIn) // Redirige vers la page d'accueil si l'utilisateur est vide
    } else {
      setUser(userData) // Set user in state
      const params = {
        mode: mode.listCommandeproductMode,
        LG_AGEID: userData.LG_AGEID,
        // LG_COMMID: userData.LG_COMMID,
      }
      fetchData(params, apiEndpointe.CommandeManagerEndPoint, setProductData)

      const paramPanier = {
        mode: mode.getClientPanierMode,
        LG_AGEID: userData?.LG_AGEID,
      }
      fetchPanierData(paramPanier, apiEndpointe.CommandeManagerEndPoint, setProductData)
      const paramsZone = {
        mode: mode.getZoneLivraisonMode,
        LIMIT: 9000,
        PAGE: 1,
      }
      fetchZoneData(paramsZone, apiEndpointe.CommandeManagerEndPoint)
    }
  }, [navigate])

  const handleCloture = () => {
    if (!selectedZone || !deliveryAddress) {
      toast.error("Veuillez remplir tous les champs obligatoires")
      return
    }
    const params = {
      mode: mode.validationCommandeMode,
      LG_AGEID: userData.LG_AGEID,
      STR_UTITOKEN: userData.STR_UTITOKEN,
      STR_COMMLIVADRESSE: deliveryAddress,
      LG_ZONLIVID: selectedZone,
    }
    //fetchUserSumAmountOrders();

    ClotuteCommproduit(params, apiEndpointe.CommandeManagerEndPoint)
  }

  const handleZoneChange = (event) => {
    setSelectedZone(event.target.value) // Mettez à jour l'état avec la valeur sélectionnée
  }

  const handleDeliveryAddressChange = (event) => {
    setDeliveryAddress(event.target.value)
  }

  // Options pour react-select
  const zoneOptions = zones ? zones.map(item => ({
    value: item.id,
    label: item.name
  })) : []

  return (
    <div className={` ${param.userData ? "bgUserConnected" : ""}`}>
      <div className="page-wrapper">
        <main className="main cart">
          <AppMenu />

          {/* En-tête de livraison */}
          <div className="container">
            <div
              className="livraison-header"
              style={{
                backgroundColor: "#E8EFF9",
                padding: "20px 25px",
                borderRadius: "10px 10px 0 0",
                marginBottom: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
                boxShadow: "0 2px 10px rgba(59, 89, 152, 0.1)",
                borderBottom: "1px solid rgba(59, 89, 152, 0.1)",
              }}
            >
              <h1
                style={{
                  color: "#3B5998",
                  fontSize: "24px",
                  fontWeight: "700",
                  margin: "0",
                  letterSpacing: "0.5px",
                  position: "relative",
                  zIndex: "1",
                }}
              >
                DÉTAILS DE LIVRAISON
              </h1>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  position: "relative",
                  zIndex: "1",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#3B5998",
                    color: "#FFFFFF",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <i className="fas fa-truck" style={{ fontSize: "12px" }}></i>
                  <span>Étape 2/3</span>
                </div>
              </div>
            </div>
          </div>

          <div className="page-content" style={{ paddingTop: "0" }}>
            <div className="container">
              <form className="form checkout-form livraison-container" action="#" method="post">
                <div
                  className="row"
                  style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "0 0 10px 10px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    padding: "30px 20px",
                    border: "1px solid #E8EFF9",
                    borderTop: "none",
                  }}
                >
                  <div className="col-lg-7 pr-lg-4 mb-4">
                    <div
                      style={{
                        backgroundColor: "#F5F8FC",
                        borderRadius: "10px",
                        padding: "25px",
                        marginBottom: "20px",
                      }}
                    >
                      <h3
                        style={{
                          color: "#3B5998",
                          fontSize: "18px",
                          fontWeight: "700",
                          marginBottom: "20px",
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        Informations de livraison
                        <div
                          style={{
                            height: "3px",
                            width: "100%",
                            background: "linear-gradient(90deg, #3B5998, #5B7EC2)",
                            position: "absolute",
                            bottom: "-8px",
                            left: "0",
                            borderRadius: "3px",
                          }}
                        ></div>
                      </h3>

                      <div
                        className="form-group"
                        style={{
                          marginBottom: "25px",
                        }}
                      >
                        <label
                          style={{
                            color: "#3B5998",
                            fontWeight: "600",
                            fontSize: "14px",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        >
                          Zone de livraison <span style={{ color: "#FF5252" }}>*</span>
                        </label>
                        <div className="select-box">
                          <Select
                            options={zoneOptions}
                            value={zoneOptions.find(option => option.value === selectedZone) || null}
                            onChange={(option) => setSelectedZone(option ? option.value : null)}
                            placeholder="Choisissez votre zone de livraison"
                            isClearable
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                padding: "6px",
                                borderRadius: "6px",
                                border: state.isFocused ? "1px solid #3B5998" : "1px solid #E8EFF9",
                                boxShadow: state.isFocused ? "0 0 0 1px #3B5998" : "0 2px 5px rgba(0,0,0,0.02)",
                                transition: "all 0.3s ease",
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? "#3B5998" : state.isFocused ? "#E8EFF9" : "white",
                                color: state.isSelected ? "white" : "#3B5998",
                                cursor: "pointer"
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: "#3B5998",
                                fontWeight: "500",
                                fontSize: "14px",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "#ADB5BD",
                                fontSize: "14px"
                              })
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            color: "#3B5998",
                            fontWeight: "600",
                            fontSize: "14px",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        >
                          Adresse de livraison <span style={{ color: "#FF5252" }}>*</span>
                        </label>
                        <input
                          type="text"
                          style={{
                            width: "100%",
                            padding: "12px 15px",
                            borderRadius: "6px",
                            border: "1px solid #E8EFF9",
                            backgroundColor: "#FFFFFF",
                            color: "#3B5998",
                            fontSize: "14px",
                            fontWeight: "500",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.02)",
                            transition: "all 0.3s ease",
                          }}
                          name="STR_COMMLIVADRESSE"
                          value={deliveryAddress || ""}
                          onChange={handleDeliveryAddressChange}
                          placeholder="Entrez votre adresse complète de livraison"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 mb-4">
                    <div className="summary-card" style={{ height: "100%" }}>
                      <div
                        style={{
                          backgroundColor: "#F5F8FC",
                          borderRadius: "10px",
                          padding: "25px",
                          height: "100%",
                          boxShadow: "0 4px 15px rgba(59, 89, 152, 0.08)",
                          position: "relative",
                        }}
                      >
                        <h3
                          style={{
                            color: "#3B5998",
                            fontSize: "18px",
                            fontWeight: "700",
                            marginBottom: "25px",
                            textAlign: "center",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                            position: "relative",
                          }}
                        >
                          Résumé de ma commande
                          <div
                            style={{
                              height: "3px",
                              width: "60px",
                              background: "linear-gradient(90deg, #3B5998, #5B7EC2)",
                              margin: "10px auto 0",
                              borderRadius: "3px",
                            }}
                          ></div>
                        </h3>

                        <div
                          style={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "8px",
                            padding: "20px",
                            marginBottom: "20px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
                          }}
                        >
                          {/* Pagination */}
                          {productData && productData.length > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginBottom: "15px",
                                gap: "10px",
                              }}
                            >
                              <button
                                type="button"
                                onClick={handlePreviousPage}
                                disabled={indexOfFirstItem <= 0}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  padding: "6px 12px",
                                  background: indexOfFirstItem <= 0 ? "#F5F8FC" : "#E8EFF9",
                                  color: indexOfFirstItem <= 0 ? "#ADB5BD" : "#3B5998",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: indexOfFirstItem <= 0 ? "not-allowed" : "pointer",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                }}
                              >
                                <i className="w-icon-long-arrow-left"></i>
                                Préc
                              </button>
                              <button
                                type="button"
                                onClick={handleNextPage}
                                disabled={indexOfLastItem >= productData.length}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  padding: "6px 12px",
                                  background: indexOfLastItem >= productData.length ? "#F5F8FC" : "#E8EFF9",
                                  color: indexOfLastItem >= productData.length ? "#ADB5BD" : "#3B5998",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: indexOfLastItem >= productData.length ? "not-allowed" : "pointer",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                }}
                              >
                                Suiv
                                <i className="w-icon-long-arrow-right"></i>
                              </button>
                            </div>
                          )}

                          {/* Liste des produits */}
                          <div
                            style={{
                              maxHeight: "250px",
                              overflowY: "auto",
                              marginBottom: "15px",
                              paddingRight: "5px",
                            }}
                          >
                            {isLoading
                              ? Array(3)
                                  .fill()
                                  .map((_, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0",
                                        borderBottom: "1px solid #E8EFF9",
                                      }}
                                    >
                                      <div className="loading-skeleton" style={{ height: "20px", width: "60%" }}></div>
                                      <div className="loading-skeleton" style={{ height: "20px", width: "30%" }}></div>
                                    </div>
                                  ))
                              : currentData.map((item, index) => (
                                  <div
                                    key={index}
                                    className="product-row"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      padding: "12px 0",
                                      borderBottom: "1px solid #E8EFF9",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "6px",
                                          border: "1px solid #E8EFF9",
                                          overflow: "hidden",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <img
                                          src={`${item.str_propic ? fullUrl + item.str_propic : fullUrl + defaultImage}`}
                                          alt={item.PlvLib}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                          onError={(e) => {
                                            e.target.src = fullUrl + defaultImage
                                          }}
                                        />
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#3B5998",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            marginBottom: "4px",
                                          }}
                                        >
                                          {item.PlvLib}
                                        </span>
                                      <span
                                        style={{
                                          color: "#6C757D",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        Quantité:
                                        <span
                                          style={{
                                            backgroundColor: "#E8EFF9",
                                            color: "#3B5998",
                                            padding: "2px 6px",
                                            borderRadius: "4px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {Number.parseInt(item.PlvQteUV)}
                                        </span>
                                      </span>
                                    </div>
                                    </div>
                                    <div
                                      style={{
                                        color: "#3B5998",
                                        fontWeight: "700",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {formatPrice(Number.parseInt(item?.PlvPUNet) * Number.parseInt(item?.PlvQteUV))}{" "}
                                      FCFA
                                    </div>
                                  </div>
                                ))}
                          </div>

                          {/* Totaux */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "15px",
                              padding: "0 0 15px",
                              borderBottom: "1px solid #E8EFF9",
                            }}
                          >
                            <span
                              style={{
                                color: "#6C757D",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              Montant HT
                            </span>
                            <span
                              style={{
                                color: "#3B5998",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              {cart && formatPrice(Number.parseInt(cart?.dbl_commmtht))} FCFA
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                color: "#3B5998",
                                fontSize: "16px",
                                fontWeight: "700",
                              }}
                            >
                              Total
                            </span>
                            <span
                              style={{
                                color: "#3B5998",
                                fontSize: "20px",
                                fontWeight: "800",
                                background: "linear-gradient(135deg, #3B5998, #5B7EC2)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              {cart && formatPrice(Number.parseInt(cart?.dbl_commmtttc))} FCFA
                            </span>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="btn-validation"
                          onClick={handleCloture}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            background: "linear-gradient(135deg, #3B5998, #5B7EC2)",
                            color: "#FFFFFF",
                            padding: "14px 20px",
                            borderRadius: "6px",
                            border: "none",
                            fontWeight: "700",
                            fontSize: "16px",
                            width: "100%",
                            textAlign: "center",
                            boxShadow: "0 4px 12px rgba(59, 89, 152, 0.25)",
                            cursor: "pointer",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onMouseOver={(e) => {
                            e.target.style.boxShadow = "0 6px 15px rgba(59, 89, 152, 0.35)"
                          }}
                          onMouseOut={(e) => {
                            e.target.style.boxShadow = "0 4px 12px rgba(59, 89, 152, 0.25)"
                          }}
                        >
                          <span style={{ position: "relative", zIndex: "1" }}>Valider la commande</span>
                          {isLoadingSpinner && <div className="loader" style={{ marginLeft: "10px" }}></div>}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Livraison
